<img
  [src]="'../../assets/images/list_purple.svg'"
  class="sort-image"
  *ngIf="!currentlyFilteredOrSorted(column) && status.openDropdown != i"
  alt="No sort of filter applied"
/>
<img
  [src]="'../../assets/images/filter_active.svg'"
  class="sort-image"
  *ngIf="currentlyFilteredOrSorted(column) && status.openDropdown != i"
  alt="Currently sorted or filtered"
/>
<img
  [src]="'../../assets/images/filter_on_click.svg'"
  class="sort-image"
  *ngIf="status.openDropdown == i"
  alt="Dropdown to sort or filter open"
/>
